module.exports = __webpack_public_path__ + "img/slide7-ru.3bff18f9.png";